/**
 * Tipologie di flusso di qualità in base alla tipologia di documenti
 */
export enum FlowType {
  Documenti = 'Documenti',
  ConsensiInformati = 'ConsensiInformati',
  Regolamenti = 'Regolamenti'
}
